import * as React from 'react'
import { OS, identifyOS } from 'core/services/browser'
import { Banner } from './banner'

const os = identifyOS()

interface IMobileBannerProps {
  iosBody: string
  androidBody: string
  iosLink: string
  androidLink: string
  cta: string
  localStorageKey: string
  bannerType: 'download-rider' | 'onboard'
}

export const MobileBanner: React.FunctionComponent<IMobileBannerProps> = ({
  iosBody,
  androidBody,
  iosLink,
  androidLink,
  cta,
  localStorageKey,
  bannerType
}) => {
  if (os === OS.ios) {
    return (
      <Banner
        bannerType={bannerType}
        body={iosBody}
        link={iosLink}
        cta={cta}
        localStorageKey={localStorageKey}
      />
    )
  }
  if (os === OS.android) {
    return (
      <Banner
        bannerType={bannerType}
        body={androidBody}
        link={androidLink}
        cta={cta}
        localStorageKey={localStorageKey}
      />
    )
  }
  return null
}
